import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Expand SVG Icon for expand widget button.
 */
export const Expand: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M18.75 11.25V5.25H12.75L15.2175 7.7175L7.7175 15.2175L5.25 12.75V18.75H11.25L8.7825 16.2825L16.2825 8.7825L18.75 11.25Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
